import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { StyledSectionItem } from '../SectionItem/styled';
import { StyledHolder } from '../../Avatar/styled';

export const StyledSectionLink = styled(StyledSectionItem).attrs({
  as: Link,
})`
  background-color: ${(p) =>
    p.isActive ? p.theme.alias.shadow : 'transparent'};

  &:hover {
    background-color: ${(p) => !p.isActive && p.theme.alias.shadow};

    ${StyledHolder} {
      background-color: ${(p) => p.theme.alias.bg};
    }
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusInner};
  }

  &:disabled {
    opacity: 0.5;
    background-color: transparent !important;
  }
`;

export const StyledSectionLinkButton = styled(StyledSectionLink).attrs({
  as: 'button',
})`
  &:hover {
    background-color: ${(p) => p.theme.alias.shadow};
  }
`;
